<script lang="ts">
	import Perks from './Perks.svelte';

	export let isMonthly: boolean = true;
	export let showCallToAction: boolean;
	export let isUsersPlan: boolean;
</script>

<div class="flex flex-col justify-center items-center">
	<div
		class="w-[22rem] h-[36rem] p-8 flex flex-col justify-center items-center border rounded
		bg-primary-50 border-primary-200
		dark:border-zinc-800 dark:bg-zinc-900"
	>
		<div class="w-full flex flex-row justify-between items-center">
			<div class="w-fit text-zinc-900 dark:text-zinc-200 text-xl font-semibold">Studio</div>
			{#if isUsersPlan}
				<div class="w-fit text-xs text-zinc-600">(your current plan)</div>
			{/if}
		</div>
		<div class="h-6"></div>
		<Perks planName="Team" checkmarkColor="text-cyan-600 dark:text-cyan-400 dark:opacity-80" />
		<div class="h-3"></div>
		<div
			class="w-full h-12 flex flex-row justify-start items-center text-zinc-600 dark:text-zinc-200"
		>
			{#if isMonthly}
				<div class="text-3.25xl font-semibold">$300</div>
				<div class="w-1"></div>
				<div class="w-10 text-xs text-zinc-600 dark:text-zinc-400">per month</div>
			{:else}
				<div class="text-3.25xl font-semibold">$300</div>
				<div class="w-1"></div>
				<div class="w-10 text-xs text-zinc-600 dark:text-zinc-400">per year</div>
			{/if}
		</div>
		<div class="h-6"></div>
		{#if showCallToAction && !isUsersPlan}
			<!-- {#if isUsersPlan}
				<div class="flex flex-row justify-center items-center">
					<div
						class="w-24 h-12 flex flex-row justify-center items-center text-center text-xs rounded text-zinc-200"
					>
						Your current plan
					</div>
					<div class="w-8 h-8"></div>
					<ManageSubscription {email} />
				</div>
			{:else if signUpOnSubscribe}
				<a
					class="w-48 h-12 flex flex-row justify-center items-center text-md font-semibold rounded shadow-lg text-zinc-900 bg-zinc-200 hover:brightness-125"
					href="/sign-up"
				>
					{subscribeWord}
				</a>
			{:else if PUBLIC_ENVIRONMENT === 'prod'}
				<a
					class="w-48 h-12 flex flex-row justify-center items-center text-md font-semibold rounded shadow-lg text-zinc-900 bg-zinc-200 hover:brightness-125"
					href="https://buy.stripe.com/00g6rtbagfJUgH600e?prefilled_email={email}"
					target="_blank"
				>
					{subscribeWord}
				</a>
			{:else if PUBLIC_ENVIRONMENT === 'dev' || PUBLIC_ENVIRONMENT === 'local'}
				<a
					class="w-48 h-12 flex flex-row justify-center items-center text-md font-semibold rounded shadow-lg text-zinc-900 bg-zinc-200 hover:brightness-125"
					href="https://buy.stripe.com/test_00g9Bh3J46sO7kY7sB?prefilled_email={email}"
					target="_blank"
				>
					{subscribeWord}
				</a>
			{/if} -->
			<a
				href="https://calendly.com/matthew-iliad/30m"
				target="_blank"
				class="w-48 h-12 flex flex-row justify-center items-center
				bg-zinc-900 hover:brightness-150 text-zinc-100 dark:bg-zinc-200 dark:hover:brightness-90 dark:text-zinc-900
				rounded font-semibold"
			>
				Talk to a human
			</a>
		{:else}
			<div
				class="w-48 h-12 flex flex-row justify-center items-center text-md rounded text-zinc-200"
			></div>
		{/if}
	</div>
</div>
